import React from 'react'
import styled from 'styled-components'
import Image from 'next/image'
import { RichTextBlock } from 'prismic-reactjs'
import { sample } from 'lodash'

import { media, AutoSpace } from '../../src/utils/style-utils'
import RichText from '../../src/components/RichText'
import { PeopleCardSliceSlice } from '../../prismicio-types'

const colors = ['var(--neon-100)', 'var(--orange)', 'var(--orange-100)', 'var(--deep-blue)', 'var(--grey)']

const PeopleCardSlice = ({ slice }: { slice: PeopleCardSliceSlice }) => {
	return (
		<PeopleCardWrapper>
			{slice.items.map((item, index) => {
				return (
					<CardWrapper key={index}>
						{item.image.url ? (
							<ImageWrapper>
								<StyledImage
									width={330}
									height={360}
									quality={100}
									src={item.image.url}
									alt={item.image.alt ?? ''}
								/>
							</ImageWrapper>
						) : (
							<RandomColorDiv color={sample(colors)!} />
						)}
						<TextWrapper>
							<TitleWrapper>
								<h2>{item.title}</h2>
							</TitleWrapper>
							<BottomWrapper>
								<JobTitle>{item.description}</JobTitle>
								<HideFromMobile>
									<EmailRichText content={item.email} />
									<NumberRichText content={item.phone_number} />
								</HideFromMobile>
							</BottomWrapper>
						</TextWrapper>
					</CardWrapper>
				)
			})}
		</PeopleCardWrapper>
	)
}
const RandomColorDiv = styled.div<{ color: string }>`
	background-color: ${(props) => props.color};
	border-radius: 40px;
	width: 100%;
	max-width: 330px;
	height: 360px;
	flex: 1;

	${media.tabletMd`
		flex: auto;
	`}
`
const JobTitle = styled.span`
	font-weight: 400;
	font-size: clamp(1.5rem, 1vw + 0.5rem, 2rem);
`

const PeopleCardWrapper = styled.div`
	margin: 0 40px;

	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${AutoSpace.desktop}px;

	${media.desktopLg`
		margin: 0 40px;
  	`}
	${media.desktopMd`
		margin: 0 24px;
		column-gap: 24px;
	`}

	${media.desktopSm`
		margin: 0 24px;
		column-gap: 16px;
		grid-template-columns: 1fr;
		gap: ${AutoSpace.tablet}px;
	`}

	${media.tablet`
		column-gap: 8px;
		margin: 0 16px;
	`}


	${media.phone`
		column-gap: 8px;
		margin: 0 8px;
	`}
`

const CardWrapper = styled.div`
	display: flex;
	flex-direction: row;
	background-color: var(--baby-blue-200);
	border-radius: 56px;
	gap: 24px;
	padding: 24px;

	${media.tabletMd`
		flex-direction: column;
		gap: 0px;
		align-items: center;
	`};
`

const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	gap: 16px;
	flex: 1;

	${media.tabletMd`
		width: 330px;
		margin: 0 0 24px 0;
		align-items: baseline;
	`}

	${media.phone`
		gap: 8px;
	`}
`

const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;

	h2 {
		font-weight: 500;
		font-size: clamp(2.5rem, 1rem, 3rem);
		line-height: 3rem;

		${media.phone`
			margin-bottom: 0px;
		`}
	}
`

const BottomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	p {
		margin: 0;
		opacity: 0.9;
		font-size: 20px;
		font-weight: 400;
	}
`

const HideFromMobile = styled.div`
	${media.phone`
		display: none;
	`}
`

const EmailRichText = styled(RichText)`
	text-decoration: underline;
	text-underline-offset: 3px;
	color: var(--blue-500);
`

const NumberRichText = styled(RichText)`
	color: var(--blue-500);
`

const ImageWrapper = styled.div`
	max-width: 330px;
	border-radius: 40px;
	height: 360px;
	flex: 1;

	img {
		border-radius: 40px;
	}

	${media.tabletMd`
		flex: auto;
	`}
`

const StyledImage = styled(Image)`
	object-fit: cover;
`

export default PeopleCardSlice
